import { render, staticRenderFns } from "./informationBlockEditable.vue?vue&type=template&id=450f1a7e&"
import script from "./informationBlockEditable.vue?vue&type=script&lang=js&"
export * from "./informationBlockEditable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports